module.exports = __webpack_public_path__ + "static/media/facebookLogo.af24f7e5.svg";